import { render, staticRenderFns } from "./BorrarSancion.vue?vue&type=template&id=4242ad04"
import script from "./BorrarSancion.vue?vue&type=script&setup=true&lang=js"
export * from "./BorrarSancion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports